export const SupportedCurrency = {
  USD: 'USD',
  GBP: 'GBP',
  AUD: 'AUD',
  INR: 'INR',
  IDR: 'IDR',
  EUR: 'EUR',
  BRL: 'BRL',
  CAD: 'CAD',
  MXN: 'MXN',
  PHP: 'PHP',
};
export type SupportedCurrency =
  (typeof SupportedCurrency)[keyof typeof SupportedCurrency];
